import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '../i18n'
//首页
import Home from '../pages/home/index.vue'/* 首页 */
import Mine from '../pages/mine/index.vue'/* 我的 */
import Choose from '../pages/choose/index.vue'/* 选妃 */
import List from '../pages/choose/list.vue'/* 选妃列表 */
import Profile from '../pages/choose/profile.vue'/* 选妃详情 */
import Video from '../pages/video/index.vue'/* 视频 */
import Game from '../pages/game/index.vue'/* 游戏 */
import Login from '../pages/login/index.vue'/* 登录 */
import Register from '../pages/login/register.vue'/* 注册 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue'/* 设置 */
import Infomation from '../pages/mine/Infomation.vue'/* 基本信息 */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Language from '../pages/mine/Language.vue'/* 语言选择 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改姓名 */
import Recharge from '../pages/mine/Recharge.vue'/* 充值 */
import SetPayPassword from '../pages/mine/SetPayPassword.vue'/* 修改提现密码 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改提现密码 */
import Lottery from '../pages/lottery/index.vue'/* 彩票详情 */
import VoteRecord from '../pages/lottery/VoteRecord.vue'/* 投票记录 */
import Notice from '../pages/mine/Notice.vue'/* 公告 */
import PlayVideo  from '../pages/video/PlayVideo'/* 视频播放页面 */
import Setbank  from '../pages/mine/Setbank'/* 视频播放页面 */
import BindCard  from '../pages/mine/BindCard'/* 绑定银行卡界面 */
import BindUsdt  from '../pages/mine/BindUsdt'/* 绑定USDT地址界面 */
import Withdraw  from '../pages/mine/Withdraw'/* 绑定银行卡界面 */
import Personalreport  from '../pages/mine/Personalreport'/* 个人表报 */
import GameRecord  from '../pages/mine/GameRecord'/* 游戏记录 */
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* 提现记录 */
import Details from '../pages/mine/details'
import WatchHistory from '../pages/video/history'
import LegacyHome from '../pages/home/legacy'
import LegacyMine from '../pages/mine/legacy'

Vue.use(VueRouter)
const routes = [
    {path:'/',redirect:'/Home',component:Home,meta:{title:'首頁'}},
    {path:'/Home',name:'home',component:Home,meta:{title:'首頁'}},
	{path:'/Choose',name:'choose',component:Choose,meta:{title:'選妃'}},
	{path:'/List',name:'list',component:List,meta:{title:'選妃列表'}},
	{path:'/Profile',name:'profile',component:Profile,meta:{title:'選妃詳情'}},
    {path:'/Mine',name:'mine',component:Mine,meta:{title:'我的'}},
    {path:'/Video',name:'video',component:Video,meta:{title:'視頻'}},
    {path:'/Game',name:'game',component:Game,meta:{title:'遊戲'}},
    {path:'/Login',name:'login',component:Login,meta:{title:'登錄'}},
    {path:'/Register',name:'register',component:Register,meta:{title:'註冊'}},
    {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{title:'在線客服'}},
    {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{title:'在線客服'}},
    {path:'/Setting',name:'Setting',component:Setting,meta:{title:'設置'}},
    {path:'/Infomation',name:'Infomation',component:Infomation,meta:{title:'基本信息'}},
    {path:'/Setname',name:'Setname',component:Setname,meta:{title:'修改真實姓名'}},
    {path:'/Setsex',name:'Setsex',component:Setsex,meta:{title:'修改性別'}},
    {path:'/Language',name:'Language',component:Language,meta:{title:'語言選擇'}},
    {path:'/Recharge',name:'Recharge',component:Recharge,meta:{title:'儲值'}},
    {path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{title:'支付密碼管理'}},
    {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{title:'登錄密碼管理'}},
    {path:'/Lottery',name:'Lottery',component:Lottery,meta:{title:'詳情頁面'}},
    {path:'/VoteRecord',name:'VoteRecord',component:VoteRecord,meta:{title:'投票記錄'}},
    {path:'/Notice',name:'Notice',component:Notice,meta:{title:'信息公告'}},
    {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{title:'視頻播放'}},
    {path:'/Setbank',name:'Setbank',component:Setbank,meta:{title:'資金管理'}},
    {path:'/BindCard',name:'BindCard',component:BindCard,meta:{title:'綁定金融卡'}},
    {path:'/BindUsdt',name:'BindUsdt',component:BindUsdt,meta:{title:'綁定USDT'}},
    {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{title:'提現'}},
    {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{title:'個人報表'}},
    {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{title:'提現記錄'}},
    {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{title:'任務記錄'}},
    {path:'/detail',name:'Details',component:Details}
    ,{path:'/WatchHistory',name:'WatchHistory',component:WatchHistory}
    ,{path:'/LegacyHome',name:'LegacyHome',component:LegacyHome}
    ,{path:'/LegacyMine',name:'LegacyMine',component:LegacyMine}

];

//生成路由实例
const router = new VueRouter({
    routes
})
const titleKeys = {
    home: 'frontend.nav.home', video: 'frontend.nav.video', game: 'frontend.nav.game', mine: 'frontend.nav.mine',
    login: 'auth.login', register: 'auth.register', Language: 'setting.language', Setting: 'setting.setting',
    WatchHistory: 'frontend.history.title', PlayVideo: 'frontend.player.title',
    ServiceOnline: 'my.online_service', ServicePage: 'my.online_service', Infomation: 'setting.base_setting',
    Setname: 'setting.modify_real_name', Setsex: 'setting.sex_place', Recharge: 'recharge.recharge',
    SetPayPassword: 'setting.finance_pwd', SetLoginPassword: 'setting.login_pwd', Lottery: 'reservation.hall',
    Notice: 'my.information_announcement', BindCard: 'setting.bind_bank_info', BindUsdt: 'frontend.titles.bind_usdt',
    Setbank: 'frontend.titles.funds', Withdraw: 'my.withdraw', Personalreport: 'my.my_statement', VoteRecord: 'reservation.vote_record',
    WithdrawRecord: 'frontend.titles.withdraw_history', GameRecord: 'my.task_record', Details: 'my.account_detail',
    choose: 'concubine.concubine', list: 'concubine.concubine', profile: 'index.personal_profile',
    LegacyHome: 'frontend.nav.home', LegacyMine: 'frontend.nav.mine'
};

export function updatePageTitle(route) {
    document.title = i18n.t(titleKeys[route.name] || 'frontend.nav.home');
}

router.beforeEach((to,from,next) => {
    updatePageTitle(to);
    next()
})

export default router

